import React from 'react'
import { Grid } from '@adsk/alloy-react-box'
import { ImageContentLoader, LabelContentLoader } from '@adsk/napi-shared'
import { AVATAR_SIZES } from '@adsk/alloy-react-avatar/es/constants'
type AvatarSizes = typeof AVATAR_SIZES
export type AvatarSize = AvatarSizes[keyof AvatarSizes]

const ReadOnlyProfileLoaderComponent: React.FC = (): JSX.Element => {
	return (
		<React.Fragment>
			<Grid gridGap={2} marginTop={'2%'} marginBottom={'2%'}>
				<LabelContentLoader />
				<LabelContentLoader />
			</Grid>
			<Grid
				gridGap={[2, 2]}
				padding={[15, 15]}
				gridAutoColumns={'auto'}
				gridTemplateColumns={['auto', ' 25% auto']}
			>
				<Grid gridGap={2} justifyContent={'center'}>
					<div style={{ position: 'relative', height: '100%' }}>
						<ImageContentLoader size={AVATAR_SIZES.XXLARGE_128} />
					</div>
				</Grid>
				<Grid gridGap={2} alignItems={'center'}>
					<div>
						<LabelContentLoader size="lg" />
						<LabelContentLoader size="md" />
						<LabelContentLoader size="sm" />
					</div>
				</Grid>
			</Grid>
			<Grid gridGap={2}>
				<LabelContentLoader size="xs" />
				<LabelContentLoader size="sm" />
				<LabelContentLoader size="xs" />
				<LabelContentLoader size="sm" />
				<LabelContentLoader size="xs" />
				<LabelContentLoader />
			</Grid>
		</React.Fragment>
	)
}

export default ReadOnlyProfileLoaderComponent
